import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["key"];
import React, { useState, createRef, useMemo } from 'react';
import styled from 'styled-components';
import Toast from './Toast';
import useToast from './useToast';
import config from './config';
const Root = styled.div.withConfig({
  displayName: "ToastContainer__Root",
  componentId: "sc-7pwjwv-0"
})(["position:fixed;display:flex;flex-direction:column-reverse;align-items:flex-end;top:var(--size-spacing-07);right:var(--size-spacing-07);z-index:var(--zindex-6);.toast-item{position:relative;top:0;left:0;right:0;bottom:0;margin-bottom:var(--size-spacing-07);}"]);

const add = (a, b) => a + b;
/**
 * @ignore - do not document.
 */


const ToastContainer = props => {
  const {
    toasts
  } = useToast();
  const hasToasts = !!(toasts && toasts.length);
  const [heights, setHeights] = useState([]);
  const refs = useMemo(() => Array.from({
    length: toasts.length
  }).map(() => /*#__PURE__*/createRef()), [toasts]);
  React.useEffect(() => {
    const heights = refs.map(node => {
      const {
        height
      } = node && node.current ? node.current.getBoundingClientRect() : {
        height: 0
      };
      return height;
    });
    setHeights(heights);
  }, [refs, setHeights]);
  return hasToasts && /*#__PURE__*/React.createElement(Root, props, toasts.slice().reverse().map((_ref, index) => {
    let {
      key
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);

    const restHeights = heights.filter((value, k) => k < index);
    const sumHeights = restHeights.reduce(add, 0);
    const offset = config.offset * restHeights.length;
    const translateY = sumHeights ? sumHeights + offset : 0;
    const style = {
      transform: "translateY(".concat(translateY, "px)")
    };
    return /*#__PURE__*/React.createElement(Toast, _extends({
      ref: refs[index],
      style: style,
      key: key
    }, rest));
  }));
};

export default ToastContainer;